// src/pages/RecuperoPassword.jsx
import React, { useState } from 'react';

// const BACKEND_URL = 'http://localhost:3001';
const BACKEND_URL = '/api';

export default function RecuperoPassword() {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage('');
    setError('');
    setLoading(true);

    try {
      const res = await fetch(`${BACKEND_URL}/forgot-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });

      const data = await res.json();

      if (!res.ok) {
        setError(data.error || 'Errore durante la richiesta.');
      } else {
        setMessage(
          data.message ||
            "Se l'utente esiste, riceverai una mail con le istruzioni."
        );
      }
    } catch (err) {
      console.error(err);
      setError('Errore di connessione al server.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="text-white font-bold">
      <form
        className="max-w-md mx-auto mt-20 p-6 bg-white shadow-md rounded"
        onSubmit={handleSubmit}
      >
        <h1 className="text-2xl font-bold mb-4 text-gray-800">
          Recupero password
        </h1>

        <p className="text-gray-700 text-sm mb-4 font-normal">
          Inserisci l&apos;email con cui effettui il login. Se l&apos;indirizzo
          è presente nel sistema, riceverai un link per reimpostare la password.
        </p>

        <input
          type="email"
          placeholder="Email"
          className="w-full mb-3 p-2 border rounded text-black"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />

        <button
          type="submit"
          disabled={loading}
          className="w-full bg-blue-600 text-white py-2 rounded hover:bg-blue-700 transition disabled:opacity-60"
        >
          {loading ? 'Invio in corso...' : 'Invia link di reset'}
        </button>

        {message && (
          <p className="text-green-600 mt-2 text-sm font-normal">{message}</p>
        )}
        {error && (
          <p className="text-red-500 mt-2 text-sm font-normal">{error}</p>
        )}
      </form>
    </div>
  );
}
